export const FAQ_TITLE = 'Common Questions';
export const KYP01_WIDGET_ID = 'KYP01';
